import styled from '@emotion/styled'

export const Heading = styled.h1`
  width: 90%;
  font-weight: normal;
  font-family: 'Open Sans', 'Helvetica Neue', sans-serif;
  font-size: 30px;
  line-height: 1.3;
  text-align: center;
  max-width: 760px;
  margin: 0;
  color: ${p => p.theme.mediumGray};

  strong {
    font-weight: bold;
    color: ${p => p.theme.darkestGray};
  }

  @media (max-width: 600px) {
    font-size: 24px;
  }
`

// The "before-tax" caveat under the heading.
export const Subheading = styled.p`
  font-family: 'Open Sans', 'Helvetica Neue', sans-serif;
  font-size: 18px;
  line-height: 1.4;
  text-align: center;
  margin: 16px 0 0;
  color: ${p => p.theme.lightestGray};
`

// Mobile-only slot for the "don't show me again" checkbox, sitting between the
// heading and the table (per the design). On desktop the checkbox lives in the
// footer instead.
export const MobileDismissRow = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 24px;
`

export const SkipRow = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 24px;
`

export const TableWrap = styled.div`
  width: 100%;
  max-width: 820px;
  margin-top: 70px;

  @media (max-width: 600px) {
    margin-top: 30px;
  }
`
